import template from "360view/b360Widgets/b360Widgets.html";
import * as moment from 'moment';

export function b360WidgetsDirective() {
  'ngInject';

  return {
    restrict: 'E',
    template: template,
    controller: p360WidgetsController,
    controllerAs: 'p360Widgets',
    bindToController: true,
    scope: {
      data: "=",
      currency: "=",
      currencyRatio: "="
    }
  };
}

class p360WidgetsController {
  constructor($filter, $scope, $translate) {
    'ngInject';

    this.$filter = $filter;
    this.$scope = $scope;
    this.$translate = $translate;
    this.$scope.$watch(() => this.data, () => this.setup());
    this.$scope.$watch(() => this.currency, () => this.setup());
    this.$scope.$watch(() =>  this.currencyRatio, () => this.setup());
    this.div0 = "DIV/0";
    this.na = "N/A";

    this.widgetsData = [
      {
        title: this.$translate.instant("VIEW360.WIDGETS.TOTAL_TURNOVER"),
        id: 'totalTurnover',
        desc: this.$translate.instant("VIEW360.WIDGETS.TOTAL_TURNOVER_DESC")
      },
      {
        title: this.$translate.instant("VIEW360.WIDGETS.HOURLY_RATE"),
        id: 'hourlyRate',
        desc: this.$translate.instant("VIEW360.WIDGETS.HOURLY_RATE_DESC")
      },
      {
        title: this.$translate.instant("SUBMENU.PROFITABILITY"),
        id: 'profitability',
        desc: this.$translate.instant("VIEW360.WIDGETS.PROFITABILITY_DESC")
      },
      {
        title: this.$translate.instant("VIEW360.WIDGETS.TOTAL_TIME"),
        id: 'timeSpent',
        desc: this.$translate.instant("VIEW360.WIDGETS.TOTAL_TIME_DESC")
      },
      {
        title: '%VA',
        id: 'va',
        desc: this.$translate.instant("VIEW360.WIDGETS.VA_DESC")
      },
      {
        title: '%NVA',
        id: 'nva',
        desc: this.$translate.instant("VIEW360.WIDGETS.NVA_DESC")
      },
      {
        title: this.$translate.instant("VIEW360.WIDGETS.TOTAL_COST"),
        id: "totalCost",
        desc: this.$translate.instant("VIEW360.WIDGETS.TOTAL_COST_DESC")
      },
      {
        title: this.$translate.instant("VIEW360.WIDGETS.TOTAL_MARGIN"),
        id: "totalMargin",
        desc: this.$translate.instant("VIEW360.WIDGETS.TOTAL_MARGIN_DESC")
      }
    ];
    this.widgetsCls = {
      timeSpent: 'time-spent',
      totalTurnover: 'total-turnover',
      va: 'va',
      nva: 'nva',
      profitability: 'profitability',
      hourlyRate: 'hourly-rate',
      totalCost: 'total-cost',
      totalMargin: 'total-margin'
    };
  }

  setup() {
    if (!this.data) {
      return;
    }

    const keys = Object.keys(this.data);
    keys.forEach(key => {
      switch (key) {
        case 'timeSpent':
          this.widgetsData[3].value = `
          ${Math.round(moment.duration(this.data.timeSpent).asHours()).toFixed(0).replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')}h
          `;
          break;
        case 'totalTurnover':
          this.widgetsData[0].value = this.currency ?
          `${(this.data.totalTurnover * this.currencyRatio).toFixed(0).replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')} ${this.currency}` :
            `${(this.data.totalTurnover * this.currencyRatio).toFixed(0).replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')}`;
          break;
        case 'vaToNva':
          this.widgetsData[4].value = `${(this.data.vaToNva * 100).toFixed(0)} %`;
          this.widgetsData[5].value = `${((1 - this.data.vaToNva) * 100).toFixed(0)} %`;
          break;
        case 'effectiveRate':
          this.widgetsData[2].value = this.data.effectiveRate.noRate == 'NotApplicable' ? this.na :
            this.data.effectiveRate.noRate == 'DivisionByZero' ? this.div0 : `${Math.round(this.data.effectiveRate.rate.ratio * 100)} %`;
          this.widgetsData[1].value = this.data.effectiveRate.noRate == 'NotApplicable' ? this.na :
            this.data.effectiveRate.noRate == 'DivisionByZero' ? this.div0 : `${(this.data.effectiveRate.rate.hourlyRate.rate * this.currencyRatio).toFixed(0).replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')} ${this.currency}`;
          break;
        case 'totalCost':
          this.widgetsData[6].value = this.currency ?
            `${(this.data.totalCost * this.currencyRatio).toFixed(0).replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')} ${this.currency}` :
            `${(this.data.totalCost * this.currencyRatio).toFixed(0).replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')}`;
          break;
        case 'totalMargin':
          this.widgetsData[7].value = this.currency ?
            `${(this.data.totalMargin * this.currencyRatio).toFixed(0).replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')} ${this.currency}` :
            `${(this.data.totalMargin * this.currencyRatio).toFixed(0).replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')}`;
          break;
      }
    });
  }
}
